import { render, staticRenderFns } from "./public-quizzes-list.html?vue&type=template&id=43833964&scoped=true&"
import script from "./public-quizzes-list.js?vue&type=script&lang=js&"
export * from "./public-quizzes-list.js?vue&type=script&lang=js&"
import style0 from "./public-quizzes-list.scss?vue&type=style&index=0&id=43833964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43833964",
  null
  
)

export default component.exports